// id	status_code	status_name	status_order
// 1	unfulfilled	Unfulfilled	1
// 2	s_requested	Shipment Requested	2
// 9	payment_expected	Awaiting payment	3
// 6	waiting_proforma	Awaiting Signing	4
// 3	proforma_signed	Shipment accepted	5
// 5	l_generated	Label Printed	6
// 10	rm_recieved	Received by Origin PO	7
// 11	omniva_recieved	Delivered to EU warehouse	8
// 7	customs_start	Handling by Customs started	9
// 4	cleared	Released by Customs	10
// 8	omniva_printed	Delivery to end customer accepted	11
// 13	s10_expected	Awaiting S10 number	12
// 12	omniva_delivered	Delivered to end customer	13

export enum EuDdpOrderStatusCode {
	UNFULFILLED = 'unfulfilled',
	SHIPMENT_REQUESTED = 's_requested',
	PAYMENT_EXPECTED = 'payment_expected',
	WAITING_PROFORMA = 'waiting_proforma',
	PROFORMA_SIGNED = 'proforma_signed',
	LABEL_PRINTED = 'l_generated',
	RECEIVED_BY_ORIGIN_PO = 'rm_recieved',
	DELIVERED_TO_EU_WAREHOUSE = 'omniva_recieved',
	HANDLING_BY_CUSTOMS_STARTED = 'customs_start',
	CLEARED = 'cleared',
	DELIVERY_TO_END_CUSTOMER_ACCEPTED = 'omniva_printed',
	S10_EXPECTED = 's10_expected',
	DELIVERED_TO_END_CUSTOMER = 'omniva_delivered',
}

export enum EuDdpOrderStatusName {
	UNFULFILLED = 'Unfulfilled',
	SHIPMENT_REQUESTED = 'Shipment Requested',
	PAYMENT_EXPECTED = 'Awaiting payment',
	WAITING_PROFORMA = 'Awaiting Signing',
	PROFORMA_SIGNED = 'Shipment accepted',
	LABEL_PRINTED = 'Label Printed',
	RECEIVED_BY_ORIGIN_PO = 'Received by Origin PO',
	DELIVERED_TO_EU_WAREHOUSE = 'Delivered to EU warehouse',
	HANDLING_BY_CUSTOMS_STARTED = 'Handling by Customs started',
	CLEARED = 'Released by Customs',
	DELIVERY_TO_END_CUSTOMER_ACCEPTED = 'Delivery to end customer accepted',
	S10_EXPECTED = 'Awaiting S10 number',
	DELIVERED_TO_END_CUSTOMER = 'Delivered to end customer',
}

export enum EuDdpOrderStatusId {
	UNFULFILLED = 1,
	SHIPMENT_REQUESTED = 2,
	PAYMENT_EXPECTED = 9,
	WAITING_PROFORMA = 6,
	PROFORMA_SIGNED = 3,
	LABEL_PRINTED = 5,
	RECEIVED_BY_ORIGIN_PO = 10,
	DELIVERED_TO_EU_WAREHOUSE = 11,
	HANDLING_BY_CUSTOMS_STARTED = 7,
	CLEARED = 4,
	DELIVERY_TO_END_CUSTOMER_ACCEPTED = 8,
	S10_EXPECTED = 13,
	DELIVERED_TO_END_CUSTOMER = 12,
}

const ORDER_STATUS_VALUES = [
	EuDdpOrderStatusName.UNFULFILLED,
	EuDdpOrderStatusName.SHIPMENT_REQUESTED,
	EuDdpOrderStatusName.PAYMENT_EXPECTED,
	EuDdpOrderStatusName.WAITING_PROFORMA,
	EuDdpOrderStatusName.PROFORMA_SIGNED,
	EuDdpOrderStatusName.LABEL_PRINTED,
	EuDdpOrderStatusName.RECEIVED_BY_ORIGIN_PO,
	EuDdpOrderStatusName.DELIVERED_TO_EU_WAREHOUSE,
	EuDdpOrderStatusName.HANDLING_BY_CUSTOMS_STARTED,
	EuDdpOrderStatusName.CLEARED,
	EuDdpOrderStatusName.DELIVERY_TO_END_CUSTOMER_ACCEPTED,
	EuDdpOrderStatusName.S10_EXPECTED,
	EuDdpOrderStatusName.DELIVERED_TO_END_CUSTOMER,
] as const;

export const ORDER_STATUS_FILTER: [string, string][] = [
	[String(EuDdpOrderStatusId.UNFULFILLED), EuDdpOrderStatusName.UNFULFILLED],
	[String(EuDdpOrderStatusId.SHIPMENT_REQUESTED), EuDdpOrderStatusName.SHIPMENT_REQUESTED],
	[String(EuDdpOrderStatusId.PAYMENT_EXPECTED), EuDdpOrderStatusName.PAYMENT_EXPECTED],
	[String(EuDdpOrderStatusId.WAITING_PROFORMA), EuDdpOrderStatusName.WAITING_PROFORMA],
	[String(EuDdpOrderStatusId.PROFORMA_SIGNED), EuDdpOrderStatusName.PROFORMA_SIGNED],
	[String(EuDdpOrderStatusId.LABEL_PRINTED), EuDdpOrderStatusName.LABEL_PRINTED],
	[String(EuDdpOrderStatusId.RECEIVED_BY_ORIGIN_PO), EuDdpOrderStatusName.RECEIVED_BY_ORIGIN_PO],
	[
		String(EuDdpOrderStatusId.DELIVERED_TO_EU_WAREHOUSE),
		EuDdpOrderStatusName.DELIVERED_TO_EU_WAREHOUSE,
	],
	[
		String(EuDdpOrderStatusId.HANDLING_BY_CUSTOMS_STARTED),
		EuDdpOrderStatusName.HANDLING_BY_CUSTOMS_STARTED,
	],
	[String(EuDdpOrderStatusId.CLEARED), EuDdpOrderStatusName.CLEARED],
	[
		String(EuDdpOrderStatusId.DELIVERY_TO_END_CUSTOMER_ACCEPTED),
		EuDdpOrderStatusName.DELIVERY_TO_END_CUSTOMER_ACCEPTED,
	],
	[String(EuDdpOrderStatusId.S10_EXPECTED), EuDdpOrderStatusName.S10_EXPECTED],
	[
		String(EuDdpOrderStatusId.DELIVERED_TO_END_CUSTOMER),
		EuDdpOrderStatusName.DELIVERED_TO_END_CUSTOMER,
	],
];

export const ORDER_STATUS_COLORS: [string, string][] = [
	[EuDdpOrderStatusName.UNFULFILLED, 'warning.light'],
	[EuDdpOrderStatusName.SHIPMENT_REQUESTED, 'primary.light'],
	[EuDdpOrderStatusName.PAYMENT_EXPECTED, 'warning.light'],
	[EuDdpOrderStatusName.WAITING_PROFORMA, 'warning.light'],
	[EuDdpOrderStatusName.PROFORMA_SIGNED, 'primary.light'],
	[EuDdpOrderStatusName.LABEL_PRINTED, 'primary.light'],
	[EuDdpOrderStatusName.RECEIVED_BY_ORIGIN_PO, 'warning.light'],
	[EuDdpOrderStatusName.DELIVERED_TO_EU_WAREHOUSE, 'primary.light'],
	[EuDdpOrderStatusName.HANDLING_BY_CUSTOMS_STARTED, 'primary.light'],
	[EuDdpOrderStatusName.CLEARED, 'primary.light'],
	[EuDdpOrderStatusName.DELIVERY_TO_END_CUSTOMER_ACCEPTED, 'success.light'],
	[EuDdpOrderStatusName.S10_EXPECTED, 'warning.light'],
	[EuDdpOrderStatusName.DELIVERED_TO_END_CUSTOMER, 'success.light'],
];

// ==============================

// { label: 'Parcel prepared for international shipment', icon: 'info' },
// { label: 'Received Origin post office', icon: 'handover' },
// { label: 'Received in transit EU country', icon: 'departed' },
// { label: 'Customs clearance completed', icon: 'arrived' },
// { label: 'In delivery to final destination', icon: 'indelivery' },
// { label: 'Delivered', icon: 'delivered' },

export const EEuDdpDeliveryStatus = {
	PARCEL_PREPARED_FOR_INTERNATIONAL_SHIPMENT: 'Parcel prepared for international shipment',
	RECEIVED_ORIGIN_POST_OFFICE: 'Received Origin post office',
	RECEIVED_IN_TRANSIT_EU_COUNTRY: 'Received in transit EU country',
	CUSTOMS_CLEARANCE_COMPLETED: 'Customs clearance completed',
	IN_DELIVERY_TO_FINAL_DESTINATION: 'In delivery to final destination',
	DELIVERED: 'Delivered',
};
export const EEuDdpDeliveryStatusId = {
	PARCEL_PREPARED_FOR_INTERNATIONAL_SHIPMENT: 1,
	RECEIVED_ORIGIN_POST_OFFICE: 2,
	RECEIVED_IN_TRANSIT_EU_COUNTRY: 3,
	CUSTOMS_CLEARANCE_COMPLETED: 4,
	IN_DELIVERY_TO_FINAL_DESTINATION: 5,
	DELIVERED: 6,
};

export const DELIVERY_STATUS_FILTER: [number, string][] = [
	[
		EEuDdpDeliveryStatusId.PARCEL_PREPARED_FOR_INTERNATIONAL_SHIPMENT,
		EEuDdpDeliveryStatus.PARCEL_PREPARED_FOR_INTERNATIONAL_SHIPMENT,
	],
	[
		EEuDdpDeliveryStatusId.RECEIVED_ORIGIN_POST_OFFICE,
		EEuDdpDeliveryStatus.RECEIVED_ORIGIN_POST_OFFICE,
	],
	[
		EEuDdpDeliveryStatusId.RECEIVED_IN_TRANSIT_EU_COUNTRY,
		EEuDdpDeliveryStatus.RECEIVED_IN_TRANSIT_EU_COUNTRY,
	],
	[
		EEuDdpDeliveryStatusId.CUSTOMS_CLEARANCE_COMPLETED,
		EEuDdpDeliveryStatus.CUSTOMS_CLEARANCE_COMPLETED,
	],
	[
		EEuDdpDeliveryStatusId.IN_DELIVERY_TO_FINAL_DESTINATION,
		EEuDdpDeliveryStatus.IN_DELIVERY_TO_FINAL_DESTINATION,
	],
	[EEuDdpDeliveryStatusId.DELIVERED, EEuDdpDeliveryStatus.DELIVERED],
];

export const DELIVERY_STATUS_COLORS: [string, string][] = [
	[EEuDdpDeliveryStatus.PARCEL_PREPARED_FOR_INTERNATIONAL_SHIPMENT, 'warning.light'],
	[EEuDdpDeliveryStatus.RECEIVED_ORIGIN_POST_OFFICE, 'primary.light'],
	[EEuDdpDeliveryStatus.RECEIVED_IN_TRANSIT_EU_COUNTRY, 'primary.light'],
	[EEuDdpDeliveryStatus.CUSTOMS_CLEARANCE_COMPLETED, 'primary.light'],
	[EEuDdpDeliveryStatus.IN_DELIVERY_TO_FINAL_DESTINATION, 'primary.light'],
	[EEuDdpDeliveryStatus.DELIVERED, 'success.light'],
];

export const EU_DDP_ACTIONS = {
	TRACKING: 'Tracking',
	PRINT_LABELS_LIST: 'Print labels list',
};
